// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.welcome-button {
  display: flex;
  flex-direction: row;
  padding: 16px 12px 24px 12px;
  justify-content: space-between;
  height: 93px;
  border: 1px solid #dddddd;
  border-radius: 5px;
  margin-bottom: 26px;
}
.welcome-button:hover {
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.welcome-button:last-of-type {
  margin-bottom: 0;
}
.welcome-button__text {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  color: #1a1e22;
  text-transform: uppercase;
  margin-top: 12px;
}
.welcome-button__arrow {
  transform: rotate(-90deg);
  width: 16px;
  height: 11px;
  align-self: center;
}
@media (min-width: 400px) {
  .welcome-button {
    padding: 16px 24px 24px 24px;
  }
  .welcome-button__text {
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 1.3px;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.welcome__shell {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.welcome__cover-picture-wrapper {
  display: none;
}
.welcome-values__wrapper {
  display: none;
}
.welcome__content-shell {
  display: flex;
  flex-direction: column;
  padding: 64px 24px;
  align-items: center;
  flex-grow: 1;
  flex-basis: 50%;
  position: relative;
}
.welcome__content-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 415px;
  width: 100%;
}
.welcome__header {
  font-weight: 600;
  color: #1a1e22;
  font-size: 36px;
}
.welcome__sub-header {
  margin-bottom: 32px;
  color: #1a1e22;
  font-size: 16px;
}
.welcome-values__facet {
  display: flex;
  align-items: center;
}
.welcome-values__facet svg {
  width: 125px;
}
@media (min-width: 950px) {
  .welcome__shell {
    display: flex;
    flex-direction: row;
    height: 100vh;
  }
  .welcome__cover-picture-wrapper {
    display: flex;
    flex-direction: row;
    display: block;
    flex-basis: 50%;
    flex-grow: 1;
    position: relative;
  }
  .welcome__content-shell {
    padding: 0 24px;
    justify-content: center;
  }
  .welcome__cover-picture {
    bottom: 0;
    flex-grow: 1;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  .welcome__cover-picture__sage-logo {
    margin-top: 24px;
    margin-left: 32px;
  }
  .welcome__cover-picture__heading {
    top: 30%;
    position: relative;
    padding: 0 64px;
    text-align: center;
    font-weight: 600;
    font-size: 48px;
    color: #fff;
  }
  .welcome__cover-picture__blurb {
    font-size: 14px;
    height: 64px;
    right: 32px;
    padding-left: 16px;
    bottom: 50px;
    color: white;
    position: absolute;
    width: 172px;
  }
  .welcome-values__sage-logo {
    margin-top: 24px;
    margin-left: 32px;
    left: 0;
    position: absolute;
    top: 0;
    max-height: 70px;
  }
  .welcome-values__content {
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
    height: 100%;
    justify-content: center;
    margin: 0 auto;
    max-width: 450px;
  }
  .welcome-values__title {
    margin-bottom: 32px;
    font-weight: 600;
    font-size: 32px;
    color: #c6eadb;
    display: flex;
    justify-content: center;
  }
  .welcome-values__info-row {
    margin-bottom: 32px;
    display: flex;
    flex-direction: row;
  }
  .welcome-values__icon-wrapper {
    flex-shrink: 0;
    height: 80px;
    width: 80px;
  }
  .welcome-values__icon-wrapper svg {
    width: 60px;
  }
  .welcome-values__wrapper {
    display: flex;
    flex-direction: row;
    background: #1b3826;
    display: block;
    flex-basis: 50%;
    flex-grow: 1;
    position: relative;
  }
  .welcome-values-info__column {
    display: flex;
    flex-direction: column;
  }
  .welcome-values-info__title {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 22px;
    color: #fff;
  }
  .welcome-values-info__title .--value-props .tooltip__icon {
    filter: brightness(10);
  }
  .welcome-values-info__description {
    font-size: 18px;
    color: #fff;
  }
}
@media (min-width: 1100px) {
  .welcome-values__content {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/sage/welcome.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,qBAAqB;EACvB;AACF;AACA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;EACR;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,WAAW;EACb;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.welcome-button {\n  display: flex;\n  flex-direction: row;\n  padding: 16px 12px 24px 12px;\n  justify-content: space-between;\n  height: 93px;\n  border: 1px solid #dddddd;\n  border-radius: 5px;\n  margin-bottom: 26px;\n}\n.welcome-button:hover {\n  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.welcome-button:last-of-type {\n  margin-bottom: 0;\n}\n.welcome-button__text {\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  color: #1a1e22;\n  text-transform: uppercase;\n  margin-top: 12px;\n}\n.welcome-button__arrow {\n  transform: rotate(-90deg);\n  width: 16px;\n  height: 11px;\n  align-self: center;\n}\n\n@media (min-width: 400px) {\n  .welcome-button {\n    padding: 16px 24px 24px 24px;\n  }\n  .welcome-button__text {\n    font-weight: 600;\n    font-size: 18px;\n    letter-spacing: 1.3px;\n  }\n}\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.welcome__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n.welcome__cover-picture-wrapper {\n  display: none;\n}\n.welcome-values__wrapper {\n  display: none;\n}\n.welcome__content-shell {\n  display: flex;\n  flex-direction: column;\n  padding: 64px 24px;\n  align-items: center;\n  flex-grow: 1;\n  flex-basis: 50%;\n  position: relative;\n}\n.welcome__content-wrapper {\n  display: flex;\n  flex-direction: column;\n  max-width: 415px;\n  width: 100%;\n}\n.welcome__header {\n  font-weight: 600;\n  color: #1a1e22;\n  font-size: 36px;\n}\n.welcome__sub-header {\n  margin-bottom: 32px;\n  color: #1a1e22;\n  font-size: 16px;\n}\n.welcome-values__facet {\n  display: flex;\n  align-items: center;\n}\n.welcome-values__facet svg {\n  width: 125px;\n}\n\n@media (min-width: 950px) {\n  .welcome__shell {\n    display: flex;\n    flex-direction: row;\n    height: 100vh;\n  }\n  .welcome__cover-picture-wrapper {\n    display: flex;\n    flex-direction: row;\n    display: block;\n    flex-basis: 50%;\n    flex-grow: 1;\n    position: relative;\n  }\n  .welcome__content-shell {\n    padding: 0 24px;\n    justify-content: center;\n  }\n  .welcome__cover-picture {\n    bottom: 0;\n    flex-grow: 1;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n  .welcome__cover-picture__sage-logo {\n    margin-top: 24px;\n    margin-left: 32px;\n  }\n  .welcome__cover-picture__heading {\n    top: 30%;\n    position: relative;\n    padding: 0 64px;\n    text-align: center;\n    font-weight: 600;\n    font-size: 48px;\n    color: #fff;\n  }\n  .welcome__cover-picture__blurb {\n    font-size: 14px;\n    height: 64px;\n    right: 32px;\n    padding-left: 16px;\n    bottom: 50px;\n    color: white;\n    position: absolute;\n    width: 172px;\n  }\n  .welcome-values__sage-logo {\n    margin-top: 24px;\n    margin-left: 32px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    max-height: 70px;\n  }\n  .welcome-values__content {\n    display: flex;\n    flex-direction: column;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 100%;\n    justify-content: center;\n    margin: 0 auto;\n    max-width: 450px;\n  }\n  .welcome-values__title {\n    margin-bottom: 32px;\n    font-weight: 600;\n    font-size: 32px;\n    color: #c6eadb;\n    display: flex;\n    justify-content: center;\n  }\n  .welcome-values__info-row {\n    margin-bottom: 32px;\n    display: flex;\n    flex-direction: row;\n  }\n  .welcome-values__icon-wrapper {\n    flex-shrink: 0;\n    height: 80px;\n    width: 80px;\n  }\n  .welcome-values__icon-wrapper svg {\n    width: 60px;\n  }\n  .welcome-values__wrapper {\n    display: flex;\n    flex-direction: row;\n    background: #1b3826;\n    display: block;\n    flex-basis: 50%;\n    flex-grow: 1;\n    position: relative;\n  }\n  .welcome-values-info__column {\n    display: flex;\n    flex-direction: column;\n  }\n  .welcome-values-info__title {\n    margin-bottom: 8px;\n    font-weight: 600;\n    font-size: 22px;\n    color: #fff;\n  }\n  .welcome-values-info__title .--value-props .tooltip__icon {\n    filter: brightness(10);\n  }\n  .welcome-values-info__description {\n    font-size: 18px;\n    color: #fff;\n  }\n}\n@media (min-width: 1100px) {\n  .welcome-values__content {\n    padding: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
